
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("57nFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $3b9ff70ffd4f2e78$var$_jquery = $3b9ff70ffd4f2e78$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $3b9ff70ffd4f2e78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $3b9ff70ffd4f2e78$var$setLinkTargets = function setLinkTargets() {
    // all links
    (0, $3b9ff70ffd4f2e78$var$_jquery["default"])("a").each(function() {
        if ((0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("href")) {
            var href = (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("href");
            var siteHostname = window.location.host;
            // check if href ends with .pdf
            var exPDF = new RegExp("\\.pdf$").test(href);
            // check if href has hostname inside
            if (href.indexOf(siteHostname) > -1) {
                if (exPDF) (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("target", "_blank");
                else (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("target", "_self");
            } else if (exPDF) (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("target", "_blank");
            else {
                // check if href starts with / or is only #
                var ex2 = new RegExp("^\\/.*|^#.*").test(href);
                if (ex2 || (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("href").includes("javascript")) (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("target", "_self");
                else (0, $3b9ff70ffd4f2e78$var$_jquery["default"])(this).attr("target", "_blank");
            }
        }
    });
};
var $3b9ff70ffd4f2e78$var$init = module.exports.init = function init() {
    var attempts = 0;
    var _whenComplete = function whenComplete() {
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") $3b9ff70ffd4f2e78$var$setLinkTargets();
        else setTimeout(function() {
            _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=linkTargets.module.5a4d0a35.js.map
